import queryString from 'query-string';
import { apiFetch } from './utils/api';

export const alternativeAssets = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `/v3/alternative-assets?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
